<div>
    <div ng-repeat="probe in $ctrl.probes" class="probe">
        <div class="label">{{probe.label}}</div>
        <div class="value" ng-class="{'flash':probe.updated, 'disabled':!probe.enabled}">{{probe.value}}</div>
        <hr/>
    </div>
</div>
